import { Routes } from '@angular/router';
import { ROOT_PATHS } from './core/constants/paths.constants';
import { authenticationGuard } from './core/guards/authentication.guard';
import { noAuthenticationGuard } from './core/guards/no-authentication.guard';

export const routes: Routes = [
  {
    path: ROOT_PATHS.home,
    loadComponent: () =>
      import('./core/layout/main-layout/main-layout').then((mod) => mod.MainLayout),
    canActivate: [authenticationGuard],
    children: [
      {
        path: ROOT_PATHS.home,
        pathMatch: 'full',
        redirectTo: ROOT_PATHS.profile,
      },
      {
        path: ROOT_PATHS.profile,
        loadComponent: () => import('./features/profile/profile').then((mod) => mod.Profile),
      },
      {
        path: ROOT_PATHS.wallet,
        loadComponent: () => import('./features/wallet/wallet').then((mod) => mod.Wallet),
      },
      {
        path: ROOT_PATHS.services,
        loadComponent: () => import('./features/services/services').then((mod) => mod.Services),
      },
      {
        path: ROOT_PATHS.invoice_history,
        loadComponent: () =>
          import('./features/invoice-history/invoice-history').then((mod) => mod.InvoiceHistory),
      },
      {
        path: ROOT_PATHS.support,
        loadComponent: () => import('./features/support/support').then((mod) => mod.Support),
      },
    ],
  },
  {
    path: ROOT_PATHS.login,
    loadComponent: () => import('./core/auth/login/login.component').then((m) => m.LoginComponent),
    canActivate: [noAuthenticationGuard],
  },
  {
    path: ROOT_PATHS.register,
    loadComponent: () =>
      import('./core/auth/registration/registration.component').then(
        (m) => m.RegistrationComponent,
      ),
    canActivate: [noAuthenticationGuard],
  },
  {
    path: ROOT_PATHS.confirm,
    loadComponent: () =>
      import('./core/auth/confirm/confirm.component').then((m) => m.ConfirmComponent),
    canActivate: [noAuthenticationGuard],
  },
  {
    path: ROOT_PATHS.mfa,
    loadComponent: () => import('./core/auth/mfa/mfa.component').then((m) => m.MfaComponent),
    canActivate: [noAuthenticationGuard],
  },
  {
    path: ROOT_PATHS.reset,
    loadComponent: () => import('./core/auth/reset/reset.component').then((m) => m.ResetComponent),
    canActivate: [noAuthenticationGuard],
  },
  {
    path: ROOT_PATHS.newPassword,
    loadComponent: () =>
      import('./core/auth/new-password/new-password.component').then((m) => m.NewPasswordComponent),
    canActivate: [noAuthenticationGuard],
  },
];
